import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { isFunction, isEmpty } from 'iotera-base/object';
import { store } from "../../../testStore";

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Object Json */
import { safeGetWithType } from 'iotera-base/json';
import { SubViewHeader } from '../../../lib/components/subHeader';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import arrayMove from 'array-move'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DragIcon from '@material-ui/icons/DragHandle';
import { setRoleEmpty } from '../../../testActions';
import { IoteraForm } from '../../../lib/components/form';
import { InlineTooltip } from '../../../lib/components/tooltips';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const ADD = "ADD";
const WKEY = "ROLE_ADD";
const wBoundActions = buildWBoundActions(WKEY);

const DragHandle = SortableHandle(() => <span style={{ cursor: 'row-resize', marginRight: 10 }}><DragIcon /></span>);

const SortableItem = SortableElement(({ value, value2 }) =>
  <ListItem className='stylizedItem' >
    <DragHandle />
    <span className='head-iotera-path'>
      {value2 !== '' ? './' + value2 + '/' : './'}
    </span>
    {value}
  </ListItem>
);

const SortableList = SortableContainer(({ items }) => {
  return (
    <List className="stylizedList" style={{ padding: 0 }}>
      {items.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value.label} value2={safeGetWithType(value, ['parentLabel'], '')} />
      ))}
    </List>
  );
});

class SortableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsId: props.dataId,
      items: props.data
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const _this = this;
    const _state = _this.state
    let items = arrayMove(_state.items, oldIndex, newIndex);
    let itemsId = arrayMove(_state.itemsId, oldIndex, newIndex);
    let onChange = safeGetWithType(this, ['props', 'onChange']);
    if (isFunction(onChange)) {
      onChange(items, itemsId);
    }
    _this.setState({ items, itemsId })
  };

  render() {
    const _this = this;
    const _state = _this.state
    return <SortableList items={_state.items} onSortEnd={_this.onSortEnd} useDragHandle />;
  }
}

function navsWithParentLabel(navsId, navs, navsArr, navsObj) {
  for (let i = 0; i < navsArr.length; i++) {
    let id = safeGetWithType(navsArr, [i, 'id'], '');
    let label = safeGetWithType(navsArr, [i, 'label'], '');
    let path = safeGetWithType(navsArr, [i, 'path'], '');
    let parent = safeGetWithType(navsArr, [i, 'parent'], '');
    if (parent === '') {
      parent = safeGetWithType(navsArr, [i, '_parent'], '');
    }
    navsId.push(
      navsArr[i].id
    );
    let navParent = safeGetWithType(navsObj, [parent], {});
    let parentLabel = safeGetWithType(navParent, ['label'], '');
    let navsBody = {
      id,
      label,
      path,
      parent,
      parentLabel
    }
    navs.push(
      navsBody
    );
  }
}

class RoleAddSort extends Component {
  constructor(props) {
    super(props)
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      this.goBack();
    } else {
      if ('role' in dataToShow) {
        if (isEmpty(dataToShow.role)) {
          this.goBack();
        } else {
          dataToShow = dataToShow.role;
        }
      } else {
        this.goBack();
      }
    }
    let navsArr = safeGetWithType(dataToShow, ['navs'], []);
    let navsObj = safeGetWithType(dataToShow, ['navsObj'], {});
    let navs = [];
    let navsId = [];
    navsWithParentLabel(navsId, navs, navsArr, navsObj);
    this.state = {
      value: [],
      formData: dataToShow,
      values: '',
      isSubmit: false,
      loading: false,
      selectedNodes: [],
      navs,
      navsId
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/role/add"
          },
          wcallback: {
            finished: function (id, result) {

              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  let action = setRoleEmpty();
                  store.dispatch(action)
                  _props.history.push('.' + S + '_role_list_');
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Tambah Role Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Tambah Role Gagal', position: 'tr', level: 'error' });
            }
          },
          wreducer: {
            enable: false
          }
        }
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleSubmit(event) {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state
    let name = safeGetWithType(_state, ['formData', 'name'], '');
    let description = safeGetWithType(_state, ['formData', 'description'], '');
    let descendant = safeGetWithType(_state, ['formData', 'descendant'], false);
    let permissions = safeGetWithType(_state, ['formData', 'permissions'], {});
    let navsId = safeGetWithType(_state, ['navsId'], []);
    _props.wSingleRequestCall({
      id: ADD,
      body: {
        name,
        description,
        descendant,
        navs: navsId,
        permissions
      }
    });
  }

  goBack() {
    this.props.history.push('.' + S + '_role_add_access_')
  };

  onChange(navs, navsId) {
    this.setState({ navs, navsId })
  }

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state
    const { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Tambah Role' subTitle='Kelola urutan dashboard yang dapat diakses oleh role ini' />
          <div className="io-container mt-12">
            <IoteraForm
              schema={{}}
              uiSchema={{}}
              onSubmit={_this.handleSubmit}
            >
              <label style={{ marginBottom: 7 }}>
                <b>Atur Urutan Navigasi*</b>
                <InlineTooltip id={'test'} text={'Akan ditampilkan urut dari atas ke bawah'} />
              </label>
              <SortableComponent data={_state.navs} dataId={_state.navsId} onChange={_this.onChange} />
              <div className="button-right" style={{ marginTop: 10 }}>
                <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                  onClick={_props.history.goBack} >Kembali</button>
                <button className="button-iotera-primary" type="submit"
                  style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</button>
              </div>
            </IoteraForm>
          </div>
        </div>
      </Loader>

    );
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(null, mapDispatchToProps)(withRouter(RoleAddSort));